import React from 'react'
// eslint-disable-next-line import/named
import { TFunction } from 'react-i18next'

import Flex from '@/modules/components/Flex'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'

type CompanyCategoryProps = {
  href: string
  tTitle: string
  tDesc?: string
  translateFn: TFunction<'navigation'>
  onClick: () => void
}

export const CompanyCategory = ({
  href,
  tTitle,
  tDesc,
  translateFn,
  onClick,
}: CompanyCategoryProps) => (
  <Link href={href} onClick={onClick} key={tTitle}>
    <Flex
      flexDirection="column"
      paddingLeft={2}
      marginBottom="20px"
      borderLeftWidth={2}
      borderLeftColor="primaryBrightBlueLightBg"
      borderLeftStyle="solid"
      ml={5}
      customCss={{
        '&:hover': {
          borderLeftColor: 'secondaryDarkNavy',
          //NOTE link title will change color when hovered
          '.linkTitle': {
            color: 'secondaryDarkNavy',
          },
        },
      }}
    >
      <Typography
        variant="subtitle2"
        color="primaryDeepBlack"
        className="linkTitle"
      >
        {translateFn(tTitle)}
      </Typography>
      {tDesc ? (
        <Typography variant="caption" color="secondaryDarkGrey">
          {translateFn(tDesc)}
        </Typography>
      ) : null}
    </Flex>
  </Link>
)
